import {component} from '../form/Constant'
import {
    patientKeys,
    patientLabelKeys,
    patientOptionsList,
} from '../patient/PatientConstants'

export const detailInformationList = [
    {
        key: 'basicInformation',
        icon: 'pi pi-info-circle',
        children: [
            {
                key: patientKeys.title,
                options: patientOptionsList.title,
                component: component.dropdown,
            },
            {key: patientKeys.firstName, component: component.inputText},
            {key: patientKeys.lastName, component: component.inputText},
            {
                key: patientKeys.email,
                component: component.inputText,
                keyFilter: true,
                placeholder: 'Field is required',
                defaultValue: '',
            },
            {
                key: patientKeys.gender,
                options: patientOptionsList.gender,
                component: component.dropdown,
            },
            {
                key: patientKeys.dob,
                component: component.inputMask,
                placeholder: 'Input date of birth',
            },
            {
                key: patientKeys.nhsNumber,
                component: component.inputText,
                placeholder: 'Field is required',
                defaultValue: '',
            },
        ],
    },
    {
        key: 'additionalInformation',
        icon: 'pi pi-user-plus',
        children: [
            {
                key: patientKeys.occupation,
                options: patientOptionsList.occupation,
                component: component.inputText,
            },
            {
                key: patientKeys.maritalStatus,
                options: patientOptionsList.maritalStatus,
                component: component.dropdown,
            },
            {
                key: patientKeys.religion,
                options: patientOptionsList.religion,
                component: component.dropdown,
            },
            {
                key: patientKeys.accommodationStatus,
                options: patientOptionsList.accommodationStatus,
                component: component.dropdown,
            },
            {
                key: patientKeys.identityWithHeldReason,
                options: patientOptionsList.identityWithHeldReason,
                component: component.dropdown,
            },
            {
                key: patientKeys.diagnostic,
                options: patientOptionsList.diagnostic,
                component: component.dropdown,
            },
            {
                key: patientKeys.currentLocation,
                component: component.inputText,
                className: 'col-12 px-0',
            },
        ],
    },
    {
        key: 'contactInformation',
        icon: 'pi pi-book',
        children: [{key: patientKeys.address, component: component.address}],
    },
    {
        key: 'generalPractitionerInformation',
        icon: 'pi pi-users',
        children: [
            {
                key: patientKeys.generalPractitioner,
                component: component.generalPractitioner,
                className: 'col-12 grid  px-0',
                childrenClassName: 'md:col-6 col-12 px-1',
            },
        ],
    },
]

export const detailHCPInformationList = [
    {
        key: 'basicInformation',
        children: [
            {
                key: patientKeys.title,
                options: patientOptionsList.hcpTitle,
                component: component.dropdown,
            },
            {key: patientKeys.firstName, component: component.inputText},
            {key: patientKeys.lastName, component: component.inputText},
            {
                key: patientKeys.gender,
                options: patientOptionsList.gender,
                component: component.dropdown,
            },
            {
                key: patientKeys.dob,
                label: patientLabelKeys.dob,
                component: component.inputMask,
                placeholder: 'Input date of birth',
            },
        ],
    },
    {
        key: 'contactInformation',
        children: [{key: patientKeys.address, component: component.address}],
    },
]

export const updateImgList = [
    {
        key: patientKeys.avatar,
        component: component.fileUpload,
        defaultValue: '',
    },
]
